import React from 'react';
import './PreloaderProgressBar.css';

const PreloaderProgressBar = ({ progress = 0, loaded = 0, total = 0, message }) => {
  // Masquer si le chargement est terminé
  if (progress >= 100 || total === 0) {
    return null;
  }

  const percentage = Math.min(100, Math.max(0, progress));
  const displayMessage = message || `Chargement ${loaded}/${total} vidéos...`;

  return (
    <div className="preloader-overlay">
      <div className="preloader-container">
        <div className="preloader-text">{displayMessage}</div>
        <div className="preloader-progress-bar">
          <div 
            className="preloader-progress-fill" 
            style={{ width: `${percentage}%` }}
          />
        </div>
        <div className="preloader-percentage">{percentage}%</div>
      </div>
    </div>
  );
};

export default PreloaderProgressBar;
